<div class="main_body">
  <div class="contents contents--license">
    <h2 class="contents__title" i18n="@@pages.license.title">オープンソースライセンス</h2>
    <p class="contents__description" i18n="@@pages.license.description">
      本アプリケーションは以下のオープンソースソフトウェアを使用しています。
    </p>

    <div class="legal-page license-page">
      <mat-card appearance="outlined" class="license-card">
        <div class="license-table-scroll">
          <table class="license-table" role="table">
            <thead>
              <tr>
                <th i18n="@@pages.license.column.name">ライブラリ</th>
                <th i18n="@@pages.license.column.version">バージョン</th>
                <th i18n="@@pages.license.column.license">ライセンス</th>
              </tr>
            </thead>
            <tbody>
              @for (dep of deps(); track dep.name) {
                <tr>
                  <td class="license-name">
                    @if (dep.homepage || dep.repository) {
                      <a [href]="dep.homepage || dep.repository"
                         target="_blank"
                         rel="noopener noreferrer">
                        {{ dep.name }}
                      </a>
                    } @else {
                      {{ dep.name }}
                    }
                  </td>
                  <td class="license-version">{{ dep.version }}</td>
                  <td>{{ dep.license }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </mat-card>
    </div>
  </div>
</div>
